import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { tap, catchError } from 'rxjs/operators';
import { environment } from "src/environments/environment";

@Injectable({providedIn:'root'})
export class NotiService{
    constructor(private httpClient: HttpClient) {}

    sendMail(notiForm:
        {
            firstName:string,
            lastName:string,
            recipientEmail:string,
            phone:string,
            subject:string,
            notification:string,
            email:string
        }
    ): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        let options = {
            headers: headers,
        }
        return this.httpClient.post(`${environment.creatoradminApi}mail/send`, notiForm, { headers, responseType: 'text' }).pipe(
            tap((response: any) => {
                console.log('responce', response)
                if(response.includes('Mail sent')) return true
                else return false
            })
        );
    }

}